import React, { useEffect, useRef, useState } from '../../_snowpack/pkg/react.js';
import styled from '../../_snowpack/pkg/styled-components.js';
import { Button, colors } from '../css/index.js';
import { hideBootingScreen } from '../helper.js';
import appConfig from '../app-config.js';
import ErrorScreen from '../modules/error-screen/index.js';
import ServerMaintenance from '../images/illustrations/http503.svg';
import ApiUnHealthy from '../images/illustrations/api-unhealthy.svg';
const {
  GRAPH_URL
} = appConfig;
const StatusBarOuter = styled.div.withConfig({
  displayName: "api-healthy-gate__StatusBarOuter",
  componentId: "sc-1j0bvhi-0"
})(["position:fixed;top:0;left:0;width:100%;color:", ";padding:15px 45px;background:", ";display:flex;align-items:center;justify-content:space-between;z-index:1;img{margin-right:30px;}button{margin-right:90px;}"], colors.frost, colors.frostbite);
const StatusBarContent = styled.div.withConfig({
  displayName: "api-healthy-gate__StatusBarContent",
  componentId: "sc-1j0bvhi-1"
})(["display:flex;align-items:center;"]);

function ApiOfflineStatusBar({
  gettingStatus,
  onStatusClick
}) {
  return /*#__PURE__*/React.createElement(StatusBarOuter, null, /*#__PURE__*/React.createElement(StatusBarContent, null, /*#__PURE__*/React.createElement("img", {
    src: "/img/icons/connection_lost.svg",
    alt: "No internet"
  }), "Teddy nooooo.... The API is having some issues"), /*#__PURE__*/React.createElement(Button, {
    loading: gettingStatus,
    onClick: onStatusClick
  }, "Check life signs"));
}

function OfflineStatusBar() {
  return /*#__PURE__*/React.createElement(StatusBarOuter, null, /*#__PURE__*/React.createElement(StatusBarContent, null, "From the looks of it, it seems like you are offline"));
}

function ApiHealthyGate(props) {
  const {
    children
  } = props;
  const [online, setOnline] = useState(true);
  const [healthy, setHealthy] = useState(false);
  const [gettingStatus, setGettingStatus] = useState(false);
  const [gettingInitialStatus, setGettingInitialStatus] = useState(true);
  const [showChildren, setShowChildren] = useState(false);
  const [underMaintenance, setUnderMaintenance] = useState(false);
  const unmounted = useRef(null);

  const handleOnline = () => {
    setOnline(true);
  };

  const handleOffline = () => {
    setOnline(false);
  };

  useEffect(() => {
    poll();
    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);
    return () => {
      unmounted.current = true;
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  });

  const poll = async () => {
    if (unmounted.current) {
      return;
    }

    await getStatus();
    setTimeout(poll, healthy ? 60000 * 5 : 5000);
  };

  const getStatus = async () => {
    if (gettingStatus) {
      return;
    }

    if (!online) {
      return;
    }

    setGettingStatus(true);

    try {
      const graph = await fetch(`${GRAPH_URL}/health`);

      if (graph.status === 502 || graph.status === 503) {
        setUnderMaintenance(true);
        hideBootingScreen();
      }

      if (graph.status === 200) {
        setHealthy(true);
        setShowChildren(true);
      } else {
        setHealthy(false);
        hideBootingScreen();
      }
    } catch (error) {
      setHealthy(false);
      hideBootingScreen();
    }

    setGettingStatus(false);
    setGettingInitialStatus(false);
  }; // Show nothing when checking the initial status


  if (gettingInitialStatus) {
    return null;
  } // Show error screen if initially not healthy


  if (!healthy && !showChildren && !underMaintenance) {
    return /*#__PURE__*/React.createElement(ErrorScreen, {
      heading: "Oh!! no...",
      image: ApiUnHealthy,
      subHeading: 'Something went wrong with the API.',
      getStatus: getStatus,
      gettingStatus: gettingStatus,
      label: 'Click refresh'
    });
  }

  if (underMaintenance) {
    return /*#__PURE__*/React.createElement(ErrorScreen, {
      heading: "Hang on! we are under maintenance",
      image: ServerMaintenance,
      subHeading: 'To make your experience seamless our team is working hard. We will be back soon!',
      getStatus: getStatus,
      gettingStatus: gettingStatus,
      label: 'Keep checking'
    });
  }

  return /*#__PURE__*/React.createElement(React.Fragment, null, children, !online && /*#__PURE__*/React.createElement(OfflineStatusBar, null), online && !healthy && /*#__PURE__*/React.createElement(ApiOfflineStatusBar, {
    onStatusClick: getStatus,
    gettingStatus: gettingStatus
  }));
}

export default ApiHealthyGate;